// @flow

import React, { Fragment } from 'react';
import cx from 'classnames';
import { Field } from 'redux-form';
import Segment from 'client/components/form/segment';
import Translate from 'client/components/translate';
import InputAge from 'client/components/form/inputAge';
import { convertToNumber } from 'client/utils/format';
import { type FormFieldType } from 'types/form.flow';

const genderSelect = ({
  input,
  meta: { touched, error },
}: FormFieldType): React$Element<typeof Fragment> => (
  <Fragment>
    <Segment
      {...input}
      value={input.value}
      id="gender-segment"
      error={touched && error}
      options={[
        { value: 'M', label: 'Male' },
        { value: 'F', label: 'Female' },
      ]}
      clickHandler={(option) => {
        input.onChange(option);
      }} />
  </Fragment>
);

const renderAge = ({ input, meta: { touched, error } }: FormFieldType): React$Element<'div'> => (
  <div className="input-group-wrapper">
    <InputAge error={touched && error} label={{ path: 'common.label.age' }} {...input} />
    <div className={cx('group-error', { error })}>
      <div className="error-message">{touched && error && <Translate {...error} />}</div>
    </div>
  </div>
);

const AGE_VALIDATIONS = ({ type }) => [
  (val: number) => (val ? undefined : { path: 'common.error.age' }),
  (val: number) => (val > 0 ? undefined : { path: 'common.error.invalidAge' }),
  (val: number) =>
    (type === 'primary' && val < 18 ? { path: 'common.error.invalidPrimaryAge' } : undefined),
];

const GENDER_VALIDATIONS = [
  (val: string) => (val && (val === 'M' || 'F') ? undefined : { path: 'common.error.gender' }),
];

type Props = {
  // It looks like member is always member[0]?
  member: string,
  index: number,
  fields: any, // redux-form property
  setEditing: Function,
  memberData: Object,
};

class NewMember extends React.PureComponent<Props> {
  ageValidations = AGE_VALIDATIONS(this.props.memberData);

  render() {
    const { member, memberData, index, fields, setEditing } = this.props;

    // a11y TODO: add keyboard listener to span with onClick */
    return (
      <div>
        <div className="member-name">
          <Translate path={`common.member.${memberData.type}`} />
          {memberData.type !== 'primary' && (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <span
              className="icon-x"
              onClick={() => {
                setEditing(false);
                fields.remove(index);
              }} />
          )}
        </div>

        <Field name={`${member}.gender`} component={genderSelect} validate={GENDER_VALIDATIONS} />
        <Field
          name={`${member}.age`}
          component={renderAge}
          normalize={convertToNumber}
          validate={this.ageValidations} />
      </div>
    );
  }
}

export default NewMember;
